import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

const ProductEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const initialFormState = {
    product_name: "",
    current_price: "",
    old_price: "",
    prod_stock: "",
    rating: "",
    description: "",
    product_details: "",
    prod_vendor_assign: "",
    prod_size: "",
    status: "",
    product_status:"",
    paid_promo: "",
    paid_approval: "",
    weight: "",
    dimension: "",
    show_seller: "no",

    main_category: "",
    sub_category: "",
    size_id: [],
    company_name: "",
    model_name: "",
    ram: "",
    rom: "",
    processor: "",
    camera: "",
    battery: "",
    operating_system: "",
    available_colors: [],
    fashion_brand_name: "",
    material: "",
    fit_type: "",
    occasion: "",
    available_size: [],
    available_color: [],
    care_instructions: "",
    prod_image: null,
    prod_multi_images: [],
    existing_multi_images: []
  };

  const [ProductUser, setProductUser] = useState(initialFormState);
  const [previewImage, setPreviewImage] = useState(null);
  const [multiPreview, setMultiPreview] = useState([]);
  const [CategoryUser, setCategoryUser] = useState([]);
  const [SubCategoryUser, setSubCategoryUser] = useState([]);
  const [Sizeuser, setSizeUser] = useState([]);
  const [ColorUser, setColorUser] = useState([]);
  const [isSizeDropdownOpen, setIsSizeDropdownOpen] = useState(false);
  const [isColorDropdownOpen, setIsColorDropdownOpen] = useState(false);
  const [loading, setLoading] = useState(true);

  // Fetch Product Data by ID
  useEffect(() => {
    const fetchProductData = async () => {
      try {
        setLoading(true);
        const formData = new FormData();
        formData.append("product_id", id);

        const response = await axios.post(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/create_get_product_by_id",
          formData
        );

        if (response.data?.status && response.data?.data) {
          const product = response.data.data;
          
          setProductUser({
            product_name: product.product_name || "",
            current_price: product.current_price || "",
            old_price: product.old_price || "",
            prod_stock: product.stock || "",
            rating: product.rating || "",
            description: product.description || "",
            product_details: product.product_details || "",
            weight: product.weight || "",
            dimension: product.dimension || "",
            show_seller: product.show_seller || "no",
            prod_vendor_assign: product.assign_vendor || "",
            prod_size: product.size || "",
            status: product.status || "",
            product_status: product.product_status || "",
            paid_promo: product.paid_promo || "",
            paid_approval: product.paid_approval || "",

            main_category: product.category_id || "",
            sub_category: product.subcategory_id || "",
            size_id: product.available_size ? product.available_size.split(',').filter(Boolean) : [],
            company_name: product.company_name || "",
            model_name: product.model_name || "",
            ram: product.ram || "",
            rom: product.rom || "",
            processor: product.processor || "",
            camera: product.camera || "",
            battery: product.battery || "",
            operating_system: product.operating_system || "",
            available_colors: product.available_colors ? product.available_colors.split(',').filter(Boolean) : [],
            fashion_brand_name: product.fashion_brand_name || "",
            material: product.material || "",
            fit_type: product.fit_type || "",
            occasion: product.occasion || "",
            available_size: product.available_size ? product.available_size.split(',').filter(Boolean) : [],
            available_color: product.available_color ? product.available_color.split(',').filter(Boolean) : [],
            care_instructions: product.care_instructions || "",
            prod_image: null,
            prod_multi_images: [],
            existing_multi_images: product.multi_image || []
          });

          // Set existing multi images preview
          if (product.multi_image && Array.isArray(product.multi_image)) {
            const existingPreviews = product.multi_image.map(
              img => `https://cyberathon.com/multivendor/${img}`
            );
            setMultiPreview(existingPreviews);
          }
        } else {
          toast.error("Failed to load product details");
        }
      } catch (error) {
        console.error("Error fetching product data:", error);
        toast.error("Failed to load product details");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchProductData();
    }
  }, [id]);

  // Fetch Categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_category"
        );
        setCategoryUser(res.data?.row || []);
      } catch (err) {
        console.error("Error fetching categories:", err);
      }
    };
    fetchCategories();
  }, []);

  // Fetch Sizes
  useEffect(() => {
    const fetchSize = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_size"
        );
        setSizeUser(response.data?.row || []);
      } catch (err) {
        console.error("Error fetching Sizes:", err);
      }
    };
    fetchSize();
  }, []);

  // Fetch Colors
  useEffect(() => {
    const fetchColour = async () => {
      try {
        const response = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_mst_prod_color"
        );
        setColorUser(response.data?.colors || []);
      } catch (err) {
        console.error("Error fetching Colours:", err);
      }
    };
    fetchColour();
  }, []);

  // Fetch Subcategories based on category
  useEffect(() => {
    const fetchSubcategories = async () => {
      if (!ProductUser.main_category) {
        setSubCategoryUser([]);
        return;
      }
      try {
        const res = await axios.get(
          "https://cyberathon.com/multivendor/index.php/Api/Master_controller/list_main_subcategory"
        );
        const all = res.data?.row || [];
        const filtered = all.filter(
          (sub) => String(sub.category_id) === String(ProductUser.main_category)
        );
        setSubCategoryUser(filtered);
      } catch (err) {
        console.error("Error fetching subcategories:", err);
      }
    };
    fetchSubcategories();
  }, [ProductUser.main_category]);

  // Generic input handler
  const handleInput = (e) => {
    const { name, value } = e.target;
    setProductUser((prev) => ({ ...prev, [name]: value }));
  };

  // Handle Size Checkbox
  const handleSizeCheckbox = (sizeId) => {
    setProductUser((prev) => {
      const currentSizes = prev.size_id || [];
      const sizeIdStr = String(sizeId);
      
      let updatedSizes;
      if (currentSizes.includes(sizeIdStr)) {
        updatedSizes = currentSizes.filter((id) => id !== sizeIdStr);
      } else {
        updatedSizes = [...currentSizes, sizeIdStr];
      }
      
      return {
        ...prev,
        size_id: updatedSizes,
        available_size: updatedSizes
      };
    });
  };

  // Handle Color Checkbox
  const handleColorCheckbox = (colorId) => {
    setProductUser((prev) => {
      const currentColors = prev.available_color || [];
      const colorIdStr = String(colorId);
      
      if (currentColors.includes(colorIdStr)) {
        return {
          ...prev,
          available_color: currentColors.filter((id) => id !== colorIdStr)
        };
      } else {
        return {
          ...prev,
          available_color: [...currentColors, colorIdStr]
        };
      }
    });
  };

   // Handle multiple images
    const handleMultiImageChange = async (e) => {
      const files = Array.from(e.target.files || []);
      const validFiles = [];
      const previews = [];
  
      for (let file of files) {
        const info = await validateImage(file);
  
        if (!info.isSquare) {
          toast.warning(
            `${file.name} is ${info.width}×${info.height}. Image will be auto-adjusted.`
          );
        }
  
        validFiles.push(file);
        previews.push(URL.createObjectURL(file));
      }
  
      setProductUser((prev) => ({ ...prev, prod_multi_images: validFiles }));
      setMultiPreview(previews);
    };
  
  
    const validateImage = (file) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);
  
        img.onload = () => {
          const isSquare = img.width === img.height;
          resolve({
            width: img.width,
            height: img.height,
            isSquare
          });
        };
  
        img.onerror = () => reject("Invalid image");
      });
    };

  // Submit Form
  const submitForm = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      // Add product_id for update
      formData.append("product_id", id);

      // Basic fields
      formData.append("product_name", (ProductUser.product_name || "").trim());
      formData.append("current_price", (ProductUser.current_price || "").trim());
      formData.append("old_price", (ProductUser.old_price || "").trim());
      formData.append("stock", (ProductUser.prod_stock || "").trim());
      formData.append("rating", (ProductUser.rating || "").trim());
      formData.append("description", (ProductUser.description || "").trim());
      formData.append("product_details", (ProductUser.product_details || "").trim());
      formData.append("weight", (ProductUser.weight || "").trim());
      formData.append("dimension", (ProductUser.dimension || "").trim());
      formData.append("assign_vendor", (ProductUser.prod_vendor_assign || "").trim());
      formData.append("show_seller", ProductUser.show_seller);
      formData.append("size", (ProductUser.prod_size || "").trim());
      let mappedStatus = "Out of Stock";  // default

      if (ProductUser.status === "In Stock") mappedStatus = "In Stock";
      if (ProductUser.status === "Out of Stock") mappedStatus = "Out of Stock";
      if (ProductUser.status === "Few Left") mappedStatus = "Few Left";

      formData.append("status", mappedStatus);

      formData.append("product_status", ProductUser.product_status || "");
      
      formData.append("paid_promo", ProductUser.paid_promo || "");
      formData.append("paid_approval", ProductUser.paid_approval || "");



      // Category fields
      formData.append("category_id", ProductUser.main_category || "");
      formData.append("subcategory_id", ProductUser.sub_category || "");
      
      formData.append(
        "size_id",
        Array.isArray(ProductUser.size_id)
          ? ProductUser.size_id.join(",")
          : ProductUser.size_id || ""
      );

      // Electronics fields
      formData.append("company_name", ProductUser.company_name || "");
      formData.append("model_name", ProductUser.model_name || "");
      formData.append("ram", ProductUser.ram || "");
      formData.append("rom", ProductUser.rom || "");
      formData.append("processor", ProductUser.processor || "");
      formData.append("camera", ProductUser.camera || "");
      formData.append("battery", ProductUser.battery || "");
      formData.append("operating_system", ProductUser.operating_system || "");
      formData.append(
        "available_colors",
        Array.isArray(ProductUser.available_colors)
          ? ProductUser.available_colors.join(",")
          : ProductUser.available_colors || ""
      );

      // Fashion fields
      formData.append("fashion_brand_name", ProductUser.fashion_brand_name || "");
      formData.append("material", ProductUser.material || "");
      formData.append("fit_type", ProductUser.fit_type || "");
      formData.append("occasion", ProductUser.occasion || "");
      formData.append(
        "available_size",
        Array.isArray(ProductUser.available_size)
          ? ProductUser.available_size.join(",")
          : ProductUser.available_size || ""
      );
      formData.append(
        "available_color",
        Array.isArray(ProductUser.available_color)
          ? ProductUser.available_color.join(",")
          : ProductUser.available_color || ""
      );
      formData.append("care_instructions", ProductUser.care_instructions || "");

      // Images
      if (ProductUser.prod_image) {
        formData.append("prod_image", ProductUser.prod_image);
      }
      if (Array.isArray(ProductUser.prod_multi_images) && ProductUser.prod_multi_images.length) {
        ProductUser.prod_multi_images.forEach((file) => {
          formData.append("multi_image[]", file);
        });
      }

      const response = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/update_create_product",
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      const data = response.data;
      const success =
        data?.status === true || data?.success === "1" || data?.status === "true";

      if (success) {
        toast.success(data?.message || "Product updated successfully!");
        navigate("/product-list");
      } else {
        toast.error(data?.message || "Failed to update product");
      }
    } catch (error) {
      console.error("API Error:", error);
      toast.error("Something went wrong while updating!");
    }
  };

  const handleToggleShowSeller = () => {
  setProductUser((prev) => ({
    ...prev,
    show_seller: prev.show_seller === "yes" ? "no" : "yes",
  }));
};


  if (loading) {
    return (
      <div className="page-content">
        <div className="container-fluid">
          <div className="text-center py-5">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-content">
      <div className="container-fluid">
        {/* Page Title */}
        <div className="row">
          <div className="col-12">
            <div className="page-title-box">
              <h4 className="mb-0 fw-semibold">Edit Product</h4>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">Product</li>
                <li className="breadcrumb-item active">Edit Product</li>
              </ol>
            </div>
          </div>
        </div>

        {/* Form Section */}
        <div className="row">
          <div className="col-xl-9 col-lg-8">
            <form onSubmit={submitForm}>
              {/* Image Upload */}
              <div className="card mb-3">
                <div className="card-header">
                  <h4 className="card-title">Product Photos</h4>
                </div>
                <div className="card-body">
                  <label className="form-label text-dark">Product Multiple Images</label>
                  <input
                    type="file"
                    multiple
                    className="form-control"
                    accept=".png,.webp,.jpg,.jpeg"
                    onChange={handleMultiImageChange}
                  />

                  <small className="text-muted d-block mt-1">
                    Recommended image size: <b>2000 × 2000 px (1:1 square)</b><br />
                    Supported formats: <b>.webp, .png</b><br />
                    Background: plain or transparent<br />
                    Max size: 500 KB per image
                  </small>
                  <div className="d-flex gap-2 mt-2">
                    {multiPreview.map((p, i) => (
                      <img
                        key={i}
                        src={p}
                        alt={`multi-${i}`}
                        className="product-preview"
                      />
                    ))}
                  </div>
                </div>
              </div>

              {/* Product Info */}
              <div className="card">
                <div className="card-header">
                  <h4 className="card-title">Product Information</h4>
                </div>
                <div className="card-body">
                  <div className="row g-3">
                    <div className="col-lg-6">
                      <label className="form-label">Product Name</label>
                      <input
                        type="text"
                        name="product_name"
                        value={ProductUser.product_name}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter product name"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Current Price</label>
                      <input
                        type="number"
                        name="current_price"
                        value={ProductUser.current_price}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="000"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Old Price</label>
                      <input
                        type="number"
                        name="old_price"
                        value={ProductUser.old_price}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="000"
                      />
                    </div>

                    {/* CATEGORY SELECTION */}
                    <div className="col-lg-6">
                      <label className="form-label">Main Category</label>
                      <select
                        className="form-control"
                        name="main_category"
                        value={ProductUser.main_category}
                        onChange={(e) =>
                          setProductUser((prev) => ({
                            ...prev,
                            main_category: e.target.value,
                            sub_category: "",
                          }))
                        }
                      >
                        <option value="">-- Select Main Category --</option>
                        {CategoryUser.map((item) => (
                          <option key={item.category_id} value={String(item.category_id)}>
                            {item.category_name}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* SUBCATEGORY */}
                    {ProductUser.main_category && (
                      <div className="col-lg-6">
                        <label className="form-label">Subcategory</label>
                        <select
                          className="form-control"
                          name="sub_category"
                          value={ProductUser.sub_category}
                          onChange={handleInput}
                        >
                          <option value="">-- Select Subcategory --</option>
                          {SubCategoryUser.map((item) => (
                            <option key={item.subcategory_id} value={String(item.subcategory_id)}>
                              {item.subcategory_name}
                            </option>
                          ))}
                        </select>
                      </div>
                    )}

                    {/* SIZE SELECTION WITH CHECKBOXES */}
                    <div className="col-lg-6">
                      <label className="form-label">Product Sizes</label>
                      <div className="position-relative">
                        <div
                          className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsSizeDropdownOpen(!isSizeDropdownOpen)}
                        >
                          <span>
                            {ProductUser.size_id && ProductUser.size_id.length > 0
                              ? `${ProductUser.size_id.length} size(s) selected`
                              : "Select sizes"}
                          </span>
                          <span>{isSizeDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        
                        {isSizeDropdownOpen && (
                          <div
                            className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 1000,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                            }}
                          >
                            <div className="p-3">
                              {Sizeuser.length > 0 ? (
                                Sizeuser.map((size) => (
                                  <div key={size.size_id} className="form-check mb-2">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`size-${size.size_id}`}
                                      checked={(ProductUser.size_id || []).includes(String(size.size_id))}
                                      onChange={() => handleSizeCheckbox(size.size_id)}
                                    />
                                    <label className="form-check-label" htmlFor={`size-${size.size_id}`}>
                                      {size.size_label || size.size}
                                    </label>
                                  </div>
                                ))
                              ) : (
                                <p className="text-muted mb-0">No sizes available</p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* COLOR SELECTION WITH CHECKBOXES */}
                    <div className="col-lg-6">
                      <label className="form-label">Product Colors</label>
                      <div className="position-relative">
                        <div
                          className="form-control d-flex justify-content-between align-items-center"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsColorDropdownOpen(!isColorDropdownOpen)}
                        >
                          <span>
                            {ProductUser.available_color && ProductUser.available_color.length > 0
                              ? `${ProductUser.available_color.length} color(s) selected`
                              : "Select colors"}
                          </span>
                          <span>{isColorDropdownOpen ? "▲" : "▼"}</span>
                        </div>
                        
                        {isColorDropdownOpen && (
                          <div
                            className="border rounded bg-white position-absolute w-100 mt-1"
                            style={{
                              maxHeight: "200px",
                              overflowY: "auto",
                              zIndex: 1000,
                              boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                            }}
                          >
                            <div className="p-3">
                              {ColorUser.length > 0 ? (
                                ColorUser.map((color) => (
                                  <div key={color.color_id} className="form-check mb-2 d-flex align-items-center">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`color-${color.color_id}`}
                                      checked={(ProductUser.available_color || []).includes(String(color.color_id))}
                                      onChange={() => handleColorCheckbox(color.color_id)}
                                    />
                                    <label className="form-check-label d-flex align-items-center" htmlFor={`color-${color.color_id}`}>
                                      <span
                                        className="d-inline-block me-2 ms-2"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          backgroundColor: color.code,
                                          border: "1px solid #ddd",
                                          borderRadius: "3px"
                                        }}
                                      ></span>
                                      {color.color_name}
                                    </label>
                                  </div>
                                ))
                              ) : (
                                <p className="text-muted mb-0">No colors available</p>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>

                    {/* ELECTRONICS BLOCK */}
                    {String(ProductUser.main_category) === "1" && (
                      <>
                        <hr className="mt-4 mb-2" />
                        <h5 className="text-primary">Electronics Specifications</h5>

                        <div className="col-lg-6">
                          <label className="form-label">Company Name</label>
                          <input
                            type="text"
                            name="company_name"
                            value={ProductUser.company_name}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Apple"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Model Name</label>
                          <input
                            type="text"
                            name="model_name"
                            value={ProductUser.model_name}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. iPhone 16"
                          />
                        </div>

                        <div className="col-12">
                          <label className="form-label">Specifications</label>
                          <div className="row g-3">
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="ram"
                                value={ProductUser.ram}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="RAM (e.g. 8GB)"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="rom"
                                value={ProductUser.rom}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="ROM (e.g. 128GB)"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="processor"
                                value={ProductUser.processor}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Processor"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="camera"
                                value={ProductUser.camera}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Camera"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="battery"
                                value={ProductUser.battery}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Battery (mAh)"
                              />
                            </div>
                            <div className="col-lg-4">
                              <input
                                type="text"
                                name="operating_system"
                                value={ProductUser.operating_system}
                                onChange={handleInput}
                                className="form-control"
                                placeholder="Operating System"
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    )}

                    {/* FASHION BLOCK */}
                    {String(ProductUser.main_category) === "2" && (
                      <>
                        <hr className="mt-4 mb-2" />
                        <h5 className="text-primary">Fashion Specifications</h5>

                        <div className="col-lg-6">
                          <label className="form-label">Brand Name</label>
                          <input
                            type="text"
                            name="fashion_brand_name"
                            value={ProductUser.fashion_brand_name}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="Enter brand name (e.g. Levi's)"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Material</label>
                          <input
                            type="text"
                            name="material"
                            value={ProductUser.material}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Cotton"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Fit Type</label>
                          <input
                            type="text"
                            name="fit_type"
                            value={ProductUser.fit_type}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Regular Fit"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Occasion</label>
                          <input
                            type="text"
                            name="occasion"
                            value={ProductUser.occasion}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Casual"
                          />
                        </div>

                        <div className="col-lg-6">
                          <label className="form-label">Care Instructions</label>
                          <input
                            type="text"
                            name="care_instructions"
                            value={ProductUser.care_instructions}
                            onChange={handleInput}
                            className="form-control"
                            placeholder="e.g. Machine wash cold"
                          />
                        </div>
                      </>
                    )}

                    {/* Common remaining fields */}
                    <div className="col-lg-6">
                      <label className="form-label">Stock</label>
                      <input
                        type="text"
                        name="prod_stock"
                        value={ProductUser.prod_stock}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter stock quantity"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Rating</label>
                      <input
                        type="text"
                        name="rating"
                        value={ProductUser.rating}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter rating (e.g. 4.5)"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Description</label>
                      <input
                        type="text"
                        name="description"
                        value={ProductUser.description}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Short product description"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Product Details</label>
                      <input
                        type="text"
                        name="product_details"
                        value={ProductUser.product_details}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Additional details"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Weight</label>
                      <input
                        type="text"
                        name="weight"
                        value={ProductUser.weight}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter weight"
                      />
                    </div>


                    <div className="col-lg-6">
                      <label className="form-label">Dimension</label>
                      <input
                        type="text"
                        name="dimension"
                        value={ProductUser.dimension}
                        onChange={handleInput}
                        className="form-control"
                        placeholder="Enter Dimension"
                      />
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Assign Vendor</label>
                      <select
                        className="form-control"
                        name="prod_vendor_assign"
                        value={ProductUser.prod_vendor_assign}
                        onChange={handleInput}
                      >
                        <option value="">Select Vendor</option>
                        <option value="H&M">H&M</option>
                        <option value="Nike">Nike</option>
                        <option value="Zara">Zara</option>
                      </select>
                    </div>

                    <div className="col-lg-6">
                    <label className="form-label">Product Status</label>
                    <select
                      className="form-control"
                      name="product_status"
                      value={ProductUser.product_status}
                      onChange={handleInput}
                    >
                      <option value="">-- None --</option>
                      <option value="Top Deals">Top Deals</option>
                      <option value="Fashion Top Deals">Fashion Top Deals</option>
                      <option value="Shop Your Favorites">Shop Your Favorites</option>
                      <option value="Special Offers">Special Offers</option>
                      <option value="Grand Global Brand">Grand Global Brand</option>
                      <option value="Shop By Category">Shop By Category</option>
                      <option value="Top Pick of the sale">Top Pick of the sale</option>
                      <option value="Crazy Deals">Crazy Deals</option>
                      <option value="Products for you">Products for you</option>
                      <option value="Groceries">Groceries</option>
                    </select>
                  </div>

                  <div className="col-lg-6">
                      <label className="form-label">Paid Promotion</label>
                      <select
                        className="form-control"
                        name="paid_promo"
                        value={ProductUser.paid_promo}
                        onChange={handleInput}
                      >
                        <option value="">-- Select Paid Promotion --</option>
                        <option value="yes">Yes</option>
                        <option value="no">No</option>
                      </select>
                    </div>

                    <div className="col-lg-6">
                      <label className="form-label">Paid Promotion Approval</label>
                      <select
                        className="form-control"
                        name="paid_approval"
                        value={ProductUser.paid_approval}
                        onChange={handleInput}
                      >
                        <option value="">-- Select Paid Promotion Approval--</option>
                        <option value="yes">Approve</option>
                        <option value="no">Reject</option>
                      </select>
                    </div>



                    <div className="col-lg-6">
                      <label className="form-label">Status</label>
                      <select
                        className="form-control"
                        name="status"
                        value={ProductUser.status}
                        onChange={handleInput}
                      >
                        <option value="">-- Select Status --</option>
                        <option value="In Stock">In Stock</option>
                        <option value="Out of Stock">Out of Stock</option>
                        <option value="Few Left">Few Left</option>
                      </select>
                    </div>

                  <div className="col-lg-6">
  <label className="form-label d-block">Show Seller Details</label>

  <div className="form-check form-switch mt-2">
    <input
      className="form-check-input"
      type="checkbox"
      id="showSellerSwitch"
      checked={ProductUser.show_seller === "yes"}
      onChange={handleToggleShowSeller}
    />
    <label className="form-check-label" htmlFor="showSellerSwitch">
      {ProductUser.show_seller === "yes"
        ? "Seller Details: ON"
        : "Seller Details: OFF"}
    </label>
  </div>

  {ProductUser.show_seller === "no" && (
    <small className="text-muted">
      Seller information will be hidden from users
    </small>
  )}
</div>


                  </div>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="p-3 bg-light mb-3 rounded">
                <div className="row justify-content-end g-2">
                  <div className="col-lg-3">
                    <button type="submit" className="btn btn-outline-secondary w-100">
                      Update Product
                    </button>
                  </div>
                  <div className="col-lg-2">
                    <Link to="/product-list" className="btn btn-primary w-100">
                      Cancel
                    </Link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer">
        <div className="container-fluid text-center py-3">
          © Venton. Crafted by{" "}
          <span className="text-danger">❤️</span> <strong>Techzaa</strong>
        </div>
      </footer>
    </div>
  );
};

export default ProductEdit;